var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","width":"150px"}},[_c('v-list',{attrs:{"dense":"","nav":""}},_vm._l((_vm.menuItems),function(item){return _c('v-list-item',{key:item.title,staticClass:"py-2",attrs:{"to":item.to}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.title))])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }